import { render, staticRenderFns } from "./select_positions.vue?vue&type=template&id=07b0c240&scoped=true&"
import script from "./select_positions.vue?vue&type=script&lang=js&"
export * from "./select_positions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b0c240",
  null
  
)

export default component.exports